import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_4 = { class: "input-group top_search" };
const _hoisted_5 = { class: "input-group-btn" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_8 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_12 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_13 = { class: "float-end" };
const _hoisted_14 = { class: "float-end hidden-xs record-count" };
const _hoisted_15 = {
    key: 0,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_16 = {
    class: "card bg-white data-grid report-schedule-grid detached overflow-x-auto",
    style: { "max-height": "calc(100vh - 300px)", "min-height": "300px" }
};
const _hoisted_17 = {
    id: "reportScheduleTable",
    class: "table table-hover bottom0 border-collapse-separate"
};
const _hoisted_18 = { class: "date-time-column" };
const _hoisted_19 = ["title"];
const _hoisted_20 = { style: { "padding": "6px" } };
const _hoisted_21 = { class: "d-flex justify-content-center" };
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.showModal) = $event)),
        "header-bg-variant": "normal",
        size: "xl"
    }, {
        title: _withCtx(() => {
            var _a;
            return [
                ((_a = _ctx.selectedModel) === null || _a === void 0 ? void 0 : _a.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "\r\n\t\t\t\tReport Scheduled " + _toDisplayString(_ctx.selectedModel.description) + " Log\r\n\t\t\t", 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, "\r\n\t\t\t\tAutomatic Discharge Report Log\r\n\t\t\t"))
            ];
        }),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "secondary",
                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.showModal = false))
                }, {
                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                            _createTextVNode(" Close\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        default: _withCtx(() => [
            _cache[33] || (_cache[33] = _createTextVNode()),
            _createVNode(_component_b_container, { clearfix: "" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.getReportLogs, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_5, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.getReportLogs && _ctx.getReportLogs(...args)))
                                }, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[29] || (_cache[29] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        (!_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_b_button, {
                                        class: "pw100",
                                        disabled: _ctx.working,
                                        key: idx,
                                        variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                        onClick: ($event) => (_ctx.setDateFilterOption(item))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[16] || (_cache[16] = _createTextVNode()),
                        (_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.startDate,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.startDate) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "From date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[11] || (_cache[11] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                        _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-default",
                                                                "data-toggle": ""
                                                            }, [
                                                                _createElementVNode("i", { class: "fa fa-calendar" })
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ]),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.endDate,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.endDate) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Until date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[14] || (_cache[14] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-default",
                                                            "data-toggle": ""
                                                        }, [
                                                            _createElementVNode("i", { class: "fa fa-calendar" })
                                                        ])
                                                    ], -1 /* CACHED */)),
                                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-secondary",
                                                        onClick: _cache[4] || (_cache[4] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                    }, "\r\n\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _cache[30] || (_cache[30] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ]),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_14, "\r\n\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]),
                    _cache[31] || (_cache[31] = _createTextVNode()),
                    (_ctx.loaded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("table", _hoisted_17, [
                                    _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", _hoisted_18, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'WhenCreated', title: 'Date/Time' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[18] || (_cache[18] = _createTextVNode()),
                                            _createElementVNode("th", null, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'Subject', title: 'Subject' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[19] || (_cache[19] = _createTextVNode()),
                                            _createElementVNode("th", null, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'Emails', title: 'To' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[20] || (_cache[20] = _createTextVNode()),
                                            _cache[21] || (_cache[21] = _createElementVNode("th", null, [
                                                _createElementVNode("span", { class: "d-flex justify-content-center" }, "Download Report")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", null, [
                                                _createElementVNode("td", null, _toDisplayString(_ctx.getDateTime(item.whenCreated)), 1 /* TEXT */),
                                                _cache[23] || (_cache[23] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(item.subject), 1 /* TEXT */),
                                                _cache[24] || (_cache[24] = _createTextVNode()),
                                                _createElementVNode("td", {
                                                    class: "large-text-ellipsis",
                                                    title: item.emails
                                                }, _toDisplayString(item.emails), 9 /* TEXT, PROPS */, _hoisted_19),
                                                _cache[25] || (_cache[25] = _createTextVNode()),
                                                _createElementVNode("td", _hoisted_20, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _createVNode(_component_b_button, {
                                                            class: "mb-0",
                                                            type: "button",
                                                            variant: "primary",
                                                            title: "Download the PDF Report file",
                                                            onClick: ($event) => (_ctx.download(item)),
                                                            style: { "padding": "3px 20px 4px 20px", "line-height": "16px" }
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                                    _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]));
                                        }), 256 /* UNKEYED_FRAGMENT */))
                                    ]),
                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                    _createElementVNode("tfoot", null, [
                                        (_ctx.noData)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[26] || (_cache[26] = [
                                                    _createElementVNode("td", {
                                                        class: "text-center",
                                                        colspan: "7"
                                                    }, [
                                                        _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records.\r\n\t\t\t\t\t\t\t\t\t")
                                                    ], -1 /* CACHED */)
                                                ]))]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }),
            _cache[34] || (_cache[34] = _createTextVNode())
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]));
}
